module.exports = __webpack_public_path__ + "img/words1.fb172be4.png";